// 一个中间件，用于管理消息发送时use_history的值，管理getHistoryList请求
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import useSWRInfinite from "swr/infinite";
import { getHistoryList } from "@/api/history";
import type { HistoryListItem } from "@/api/history/Types";

interface HistoryStore {
  useHistory: number;
  setUseHistory: (useHistory: number) => void;
}

export const useHistoryStore = create<HistoryStore>()(
  persist(
    (set) => ({
      useHistory: 1,
      setUseHistory: (useHistory) => set({ useHistory }),
    }),
    {
      name: "usehistory-storage",
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export const useHistoryList = () => {
  const PAGE_SIZE = 15;
  const getKey = (
    index: number,
    previousPageData: HistoryListItem[] | null
  ) => {
    if (previousPageData && !previousPageData.length) return null;

    return ["/api/session/session_list", index + 1, PAGE_SIZE];
  };

  const fetcher = async ([, page, size]: [string, number, number]) => {
    const response = await getHistoryList(page, size);
    return ((response as any).data as HistoryListItem[]) || [];
  };

  const { data, error, size, setSize, isLoading, mutate } = useSWRInfinite(
    getKey,
    fetcher,
    {
      revalidateOnFocus: false,
      shouldRetryOnError: false,
      revalidateFirstPage: false,
      persistSize: true,
    }
  );

  const historyData = data ? data.flat() : [];

  const isLoadingMore =
    isLoading || (size > 0 && data && typeof data[size - 1] === "undefined");

  const isReachingEnd = data
    ? data[data.length - 1]?.length < PAGE_SIZE
    : false;

  return {
    historyData,
    isLoading,
    isLoadingMore,
    isError: error,
    isReachingEnd,
    mutate,
    loadMore: () => setSize(size + 1),
  };
};
